import React from "react";
import { FaExternalLinkAlt, FaFilePdf } from "react-icons/fa";
import "../../../../styles/feedAgm.css";

// Rules & Acts (AGM & Board): the two Acts an FPO / company is governed by - each with the official website and
// a copy of the Act as a PDF to download (public/assets/docs/acts/).
const ACTS = [
  {
    id: "companies",
    title: "Companies Act, 2013",
    description: "Ministry of Corporate Affairs. Applies to producer companies and other companies.",
    url: "http://mca.gov.in/content/mca/global/en/home.html",
    site: "mca.gov.in",
    pdf: "/assets/docs/acts/companies-act-2013.pdf",
    pdfName: "Companies-Act-2013.pdf",
    pdfSize: "1.9 MB",
  },
  {
    id: "mscs",
    title: "Multi-State Co-operative Societies Act, 2002",
    description: "As amended in 2023. Central Registrar of Co-operative Societies.",
    url: "https://www.cooperation.gov.in/en/crcs",
    site: "cooperation.gov.in",
    pdf: "/assets/docs/acts/mscs-act-2002-amendment-2023.pdf",
    pdfName: "MSCS-Act-2002-Amendment-2023.pdf",
    pdfSize: "760 KB",
  },
];

const RulesActsPage = () => (
  <div className="user-wrapper py-4">
    <div className="user-card">
      <div className="border-bottom pb-2 mb-4">
        <h4 className="user-card-title">Rules &amp; Acts</h4>
      </div>

      <div className="agm-acts">
        {ACTS.map((act) => (
          <section key={act.id} className="agm-act" aria-labelledby={`act-${act.id}`}>
            <img src="/assets/img/services/agm/rulesandact.webp" alt="" width="60" height="60" />
            <h5 id={`act-${act.id}`} className="agm-act-title">{act.title}</h5>
            <p className="agm-act-text">{act.description}</p>
            <div className="agm-act-actions">
              <a href={act.pdf} download={act.pdfName} className="agm-btn is-primary">
                <FaFilePdf aria-hidden="true" /> Download PDF <span className="agm-act-size">{act.pdfSize}</span>
              </a>
              <a href={act.url} target="_blank" rel="noopener noreferrer" className="agm-btn">
                <FaExternalLinkAlt aria-hidden="true" /> Visit {act.site}
              </a>
            </div>
          </section>
        ))}
      </div>
    </div>
  </div>
);

export default RulesActsPage;
